export const ROOT = '/';
export const LOGIN_PATH = '/login';
export const LOGOUT_PATH = '/logout';
export const MANAGEMENT_PATH = 'system-management';
export const USER_GROUP_PATH = 'user-group';
export const USER_MANAGEMENT_PATH = 'user-management';
export const USER_CAMPAIGN_PATH = 'user-campaign';
export const QUESTION_BANK_PATH = '/question-bank';
export const QUESTION_BANK_ADD_PATH = 'question-add';
export const QUESTION_BANK_EDIT = 'question-edit';
export const QUESTION_BANK_EDIT_PATH = `${QUESTION_BANK_EDIT}/:id`;
export const SURVEY_LIST_PATH = 'survey-list';
export const SURVEY_ADD = 'survey-add';
export const SURVEY_ADD_QUESTION = `${SURVEY_ADD}/:id`;
export const SURVEY_EDIT = 'survey-edit';
export const SURVEY_VIEW = 'survey-view';
export const SURVEY_EDIT_PATH = `${SURVEY_EDIT}/:id`;
export const SURVEY_PREVIEW = 'survey-preview';
export const SURVEY_EXECUTE = 'survey-execute';
export const SURVEY_EXECUTE_HASHCODE = 'survey-execute/:hashCode';
export const NAVIATE_ADDING_QUESTION_IN_SURVEY = `/${SURVEY_LIST_PATH}/${SURVEY_ADD}/`;
export const SURVEY_LIST_PREVIEW_PATH = 'preview-survey-device';
export const REPORT_PATH = 'report';
export const REPORT_RESULT = 'results';
export const SUPPORT_PATH = 'support';
export const SYSTEM_USER_GROUP_PATH = '/system-management/user-group';
export const QUESTION_BANK_VIEW = 'question-view';
export const QUESTION_BANK_VIEW_PATH = `${QUESTION_BANK_VIEW}/:id`;
export const SURVEY_REPORT_PATH = `/${SURVEY_LIST_PATH}/${SURVEY_ADD}/`;
export const REDEEM_PATH = '/redeem';

export const PATH_ALL = 'all';
export const NOT_FOUND_PATH = '*';
export const NO_PERMISSION_PATH = 'no-permission';
export const SURVEY_LIST_BY_USER = 'surveys-by-user';
